import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import $ from "jquery";
import { Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet";
import {
  Slider,
  CategoryWidget,
  FeaturedProduct,
  ProductCollection,
  LineLoader,
  NewsScroll,
} from "../../elements";
import API from "../../../utils/API";
import { Api } from "../../../utils/Variables";
import { getCookieField, removeBothSlash } from "../../../utils";
import { CircleSlowLoader } from "../../../elements";

class Qnm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      report: [],
      id: this.props.match.params.id,
      code: this.props.match.params.code,
    };
  }

  componentDidMount() {
    this.loadReportPage();
  }

  componentWillReceiveProps(props) {
    this.state.id = props.match.params.id;
    this.state.code = props.match.params.code;
    this.loadReportPage();
  }

  getType() {
    try {
      var path = window.location.pathname;
      var paths = removeBothSlash(path).trim().split("/");
      return paths[1];
    } catch (error) {
      return "qnm";
    }
  }

  loadReportPage() {
    try {
      this.setState({ showLoader: true, report: [] });
      var form = new FormData();
      form.append("id", this.state.id);
      form.append("code", this.state.code);
      //form.append("type", this.getType());
      API.post("site/v1/ssr/report", form).then((res) => {
        if (res["data"].status == "1") {
          this.setState({ report: res["data"].data, showLoader: false });
        } else {
          this.setState({ showLoader: false });
        }
      });
    } catch (error) {
      console.log(error);
      this.setState({ showLoader: false });
    }
  }

  getField(fieldName) {
    try {
      var d = this.state.report;
      return d[fieldName];
    } catch (error) {}
  }

  render() {
    return (
      <div>
        {this.state.showLoader ? (
          <CircleSlowLoader />
        ) : (
          <div>
            <Row>
              <Col md={12}>
                <h3 className="ssr_report_title">
                  {this.getField("page_title")}
                </h3>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <div
                  dangerouslySetInnerHTML={{
                    __html: this.getField("report_content"),
                  }}
                />
              </Col>
            </Row>
          </div>
        )}
      </div>
    );
  }
}
export default Qnm;
